/** Opt-in, read-only browser certification. Disabled for ordinary visitors. */
const enabled = typeof window !== 'undefined' && window.location.hash === '#catalog-profile';
const samples: Record<string, unknown>[] = [];
let indexPublishedAt = 0;
let firstCommitRecorded = false;
let observingFirstRender = false;
const write = (sample: Record<string, unknown>) => {
    if (!enabled) return;
    samples.push(sample);
    console.info('[CATALOG_PERFORMANCE]', JSON.stringify(sample));
    let output = document.getElementById('catalog-performance-evidence');
    if (!output) { output = document.createElement('output'); output.id = 'catalog-performance-evidence'; output.hidden = true; document.body.append(output); }
    output.textContent = JSON.stringify(samples);
};
export const catalogResponseTransform = (path: string) => (body: unknown): unknown => {
    const started = performance.now();
    const value: unknown = typeof body === 'string' ? JSON.parse(body) : body;
    if (enabled) {
        const resource = performance.getEntriesByName(new URL(path, window.location.href).href).at(-1) as PerformanceResourceTiming | undefined;
        write({ phase: 'response', path, parseMs: performance.now() - started,
            transferMs: resource ? resource.responseEnd - resource.responseStart : null,
            ttfbMs: resource ? resource.responseStart - resource.requestStart : null,
            requestMs: resource?.duration ?? null, transferBytes: resource?.transferSize ?? null,
            decodedBytes: resource?.decodedBodySize ?? null });
    }
    return value;
};
export const catalogIndexPublished = () => { if (enabled) indexPublishedAt = performance.now(); };
export const catalogRenderCommitted = (brands: number, models: number) => {
    if (!enabled || !indexPublishedAt || firstCommitRecorded || observingFirstRender) return;
    observingFirstRender = true;
    const commitMs = performance.now() - indexPublishedAt;
    const observe = () => {
        const target = document.querySelector<HTMLElement>('main [data-catalog-brand-id], main [data-catalog-model-id], [data-repair-model-id]');
        const visible = target && target.getBoundingClientRect().height > 0;
        if (!visible) {
            if (performance.now() - indexPublishedAt < 15000) requestAnimationFrame(observe);
            else { observingFirstRender = false; write({ phase: 'catalog-visibility-not-observed', brands, models }); }
            return;
        }
        firstCommitRecorded = true;
        write({ phase: 'first-useful-catalog-render', navigationMs: performance.now(), commitMs,
            brands, models, images: Array.from(document.querySelectorAll<HTMLImageElement>('#root img')).map(image => ({ url: image.currentSrc || image.src, loaded: image.complete && image.naturalWidth > 0, lazy: image.loading === 'lazy' })) });
    };
    requestAnimationFrame(observe);
};
